import { useEffect, useState } from "react";

import {
    ActivityTimeline,
    ActivityTimelineItem,
    Divider,
    SummaryCard,
    SummaryCardColumn,
    useBelowBreakpoint,
} from "@impero-com/ui";
import Title from "antd/es/typography/Title";
import { cx } from "class-variance-authority";
import Skeleton from "react-loading-skeleton";

import * as timeline from "./ControlActivityTimeline.css";
import * as theme from "./ControlActivityTimelineSkeleton.css";

const ROW_COUNT = 5;

// Wait this long before revealing the skeleton so quick loads don't flash it.
const REVEAL_DELAY_MS = 300;

export function ControlActivityTimelineSkeleton() {
    const isStacked = useBelowBreakpoint("sm");
    const [visible, setVisible] = useState(false);

    // Reveals once the delay elapses; stays mounted (and sized) meanwhile.
    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), REVEAL_DELAY_MS);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={cx(timeline.root, !visible && theme.hidden)}>
            <SummaryCard vertical={isStacked}>
                <SummaryCardColumn heading={<Skeleton width={220} />}>
                    <Skeleton width={180} />
                </SummaryCardColumn>

                <Divider orientation={isStacked ? "horizontal" : "vertical"} />

                <SummaryCardColumn heading={<Skeleton width={160} />}>
                    <Skeleton width={200} />
                    <Skeleton width={200} />
                </SummaryCardColumn>
            </SummaryCard>

            <Title level={5}>
                <Skeleton width={120} />
            </Title>

            <ActivityTimeline>
                {Array.from({ length: ROW_COUNT }, (_, index) => (
                    <ActivityTimelineItem
                        key={index}
                        date={<Skeleton width={80} />}
                        time={<Skeleton width={60} />}
                        title={<Skeleton width={100} />}
                        subtitle={<Skeleton width={140} />}
                    />
                ))}
            </ActivityTimeline>
        </div>
    );
}
